import { applyMiddleware, combineReducers, createStore } from "redux";
import { reducer as formReducer } from "redux-form";
import thunkMiddleware from "redux-thunk";

import BookingFormReducer from "./bookingFormReducer";
import BookingReducer from "./bookingReducer";
import CbtReducer from "./cbtReducer";
import ClientReducer from "./clientReducer";
import FormsReducer from "./forms";
import HeaderSearchFormReducer from "./headerSearchFormReducer";
import HotelsReducer from "./hotelsReducer";
import LoaderReducer from "./loaderReducer";
import MessageCenterReducer from "./messageCenterReducer";
import MobileFormsReducer from "./mobileFormsReducer";
import PriceReducer from "./priceReducer";
import RequestorConfig from "./requestorConfigReducer";
import SearchReducer from "./searchReducer";
import StorageReducer from "./storageReducer";
import {
  BookingFormState,
  BookingState,
  CbtState,
  ClientState,
  FormsState,
  HeaderSearchFormState,
  HotelsState,
  IStorageData,
  LoaderState,
  MessageCenterState,
  MobileFormsState,
  PriceState,
  RequestorConfigState,
  SearchState,
  UserState,
} from "./types";
import UserReducer from "./userReducer";

export const rootReducer = combineReducers({
  search: SearchReducer,
  storage: StorageReducer,
  booking: BookingReducer,
  form: formReducer,
  requestorConfig: RequestorConfig,
  loading: LoaderReducer,
  mobileForms: MobileFormsReducer,
  user: UserReducer,
  client: ClientReducer,
  forms: FormsReducer,
  cbt: CbtReducer,
  price: PriceReducer,
  hotels: HotelsReducer,
  bookingForm: BookingFormReducer,
  messageCenter: MessageCenterReducer,
  headerSearchForm: HeaderSearchFormReducer,
});

export type AppState = {
  search: SearchState;
  storage: IStorageData;
  booking: BookingState;
  form: any;
  requestorConfig: RequestorConfigState;
  loading: LoaderState;
  mobileForms: MobileFormsState;
  user: UserState;
  client: ClientState;
  forms: FormsState;
  cbt: CbtState;
  price: PriceState;
  hotels: HotelsState;
  bookingForm: BookingFormState;
  messageCenter: MessageCenterState;
  headerSearchForm: HeaderSearchFormState;
};

export function initializeStore() {
  return createStore(rootReducer, applyMiddleware(thunkMiddleware));
}
